<template>
    <div >
 		<input type="text" name="" v-model="val" />

 		<button @click="check">check</button>

    </div>

</template>
<script>
    export default{
        name:'hotel-readme',
        data(){
            return{
                val:''
            }
        },
      	methods:{
	        check () {
	        	   var email =this.val;
                    if (!email.match(/^([A-Za-z0-9_\-\.])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/)) {
                        console.log('error')
                        return;
                    }else{
                    	console.log('succeed');
                    }

	          
	        }
      	}
    }
</script>
<style scoped="">
	input{
		width: 80%;
    height: 0.6rem;
    border: none;
    outline: none;
    vertical-align: middle;
    font-size: .22rem;
    background-color: #fff;
    border:1px solid #ccc;
	}
</style>



// WEBPACK FOOTER //
// src/components/test/test.vue